import dayjs from "dayjs";

import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { MobileDatePicker as MUIDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Custom } from "components";

type Props = {
  label: string;
  value: string | null;
  required?: boolean;
  onChange: (value: any) => void;
};

export const DatePicker = ({
  label,
  value,
  required = false,
  onChange,
}: Props) => {
  const [open, setOpen] = useState(false);
  const minDate = dayjs().format("YYYY-MM-DD");

  // Determine initial view based on whether a date exists
  const getInitialView = () => {
    if (!value) return "year"; // if no value, start from year
    return "day"; // if value exists, go straight to day
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MUIDatePicker
        open={open}
        label={label}
        minDate={minDate}
        value={value ? dayjs(value) : null}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        views={["year", "month", "day"]}
        openTo={getInitialView() as any}
        onChange={(value) => {
          onChange(dayjs(value).format("YYYY-MM-DD"));
        }}
        renderInput={(params) => (
          <Custom.TextField {...params} required={required} />
        )}
      />
    </LocalizationProvider>
  );
};
